window.angular
    .module('hippoAgreement', [
        'hippo',
        'hippoComponents',
        'hippo-consts',
        'boriskozo.async-locks',
        'moneyFilter',
        'currencyNumber',
        'ngMessages',
        'ngCookies',
        'uuid',
        'ngDialog',
        'abbreviate',
        'displayFromOptions',
        'replacementCostRange'
    ])
    .config(function (ngDialogProvider, $httpProvider, $locationProvider) {
        'ngInject';
        ngDialogProvider.setDefaults({
            className: 'hippo-dialog',
            plain: true,
            closeByEscape: true,
            showClose: false,
            closeByDocument: true,
            closeByNavigation: true
        });
        ngDialogProvider.setOpenOnePerName(true);

        $locationProvider.hashPrefix('');

        // initialize get if not there
        if (!$httpProvider.defaults.headers.get) {
            $httpProvider.defaults.headers.get = {};
        }

        // Answer edited to include suggestions from comments
        // because previous version of code introduced browser-related errors

        // disable IE ajax request caching
        $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
        // extra
        $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
        $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
    })
    .run(function ($window) {
        'ngInject';
        $window.$($window.document).on('focus', 'input, textarea', function () {
            $window.$($window.document.body).addClass('when-keyboard-showing');
        });
        $window.$($window.document).on('blur', 'input, textarea', function () {
            $window.$($window.document.body).removeClass('when-keyboard-showing');
        });
    })
    .controller(
        'agreementController',
        function (
            $scope,
            $window,
            $timeout,
            $http,
            $interpolate,
            userDataService,
            apiService,
            featureToggle,
            $location,
            $log,
            WorkflowPlan,
            ngDialog,
            pageGenerator,
            errorPage,
            overridesService,
            HIPPO_CONSTS,
            analyticsService
        ) {
            'ngInject';
            $window.scope = $scope;

            $scope.pages = {};
            $scope.lenders = [];
            $scope.confirmedCoverages = [];

            const { $, _ } = $window;
            const REQUIRED_PAGES = ['final-quote', 'call-us', 'confirmation', 'checkout'];
            const overrides = [
                {
                    key: 'final-quote',
                    title: `{{customerName}}, welcome to Hippo!`,
                    subheadline:
                        'Good to go? Simply review and accept the terms and conditions to complete the purchase of your home insurance policy',
                    style: 'review',
                    active: true,
                    showMobileEditButton: false,
                    showLicenseNumber: false,
                    showExternalLicenseNumber: true,
                    noContinue: false,
                    legalFooterHtml: `By clicking “I Accept”, you agree to each of the following:
      <ul>
        <li>Affirm you are the named insured.</li>
        <li>Declare that the information provided in this application is correct and complete to the best of your knowledge.</li>
        <li>Acknowledge you are electronically signing for the insurance indicated.</li>
      </ul>`,
                    sections: [
                        {
                            deepKey: 'leadData.personal_information.address',
                            hide: false
                        },
                        {
                            deepKey: 'leadData.personal_information.effective_date',
                            action: null,
                            tooltipContent: null
                        }
                    ],
                    eventOnPageActive: () => null
                }
            ];

            $scope.errorData = {
                // Default Error Message
                title: 'Hmmm... Something seems to have gone wrong',
                messages: [
                    `We'd like to complete this purchase but can't for some reason. Simply call us at ${HIPPO_CONSTS.HIPPO_SUPPORT_PHONE_NUMBER} and we'll clear it up.`
                ],
                parameters: []
            };
            $scope.theme = 'new-design dark-mode';

            // Page generation
            const defaultErrorPage = errorPage.get();
            function generatePages(state, product, customerName, carrier, flowCustomizationKey) {
                let pages = WorkflowPlan.getPages(state, product, carrier, flowCustomizationKey);
                if (!pages) {
                    throw new Error(`missing pages for state_product_carrier = [${state}_${product}_${carrier}]`);
                }
                // Apply Agreement Overrides
                pages = overridesService.applyPagesOverrides(pages, overrides);

                const keyedPages = _.keyBy(pages, 'key');
                const finalQuote = keyedPages['final-quote'];
                finalQuote.title = $interpolate(finalQuote.title)({ customerName });
                const agreementPages = pages.filter((page) => _.includes(REQUIRED_PAGES, page.key));
                return _.keyBy(agreementPages, 'key');
            }

            function handleError(error) {
                if (error) $scope.errorData = error.data;
                $scope.page = pageGenerator.generatePage($scope.pages['call-us'] || defaultErrorPage);
            }
            // URL format looks like this:  '/agreement.html#/?agreementId=123'
            // In this example, it will pull out agreementId query parameter value after
            // the '#/'.
            const locationSearch = $location.search();
            const showMockData = locationSearch.mock === 'true';
            const approvalId = locationSearch.agreementId;

            $scope.handleDeepEvent = function ($event) {
                if ($event.eventType === 'change') {
                    _.set($scope, $event.field.deepKey, $event.parameters.value);
                } else if ($event.eventType === 'next') {
                    $scope.continue();
                } else if ($event.eventType === 'info') {
                    $scope.showModal($event.field.infoModal);
                } else if ($event.eventType === 'error') {
                    handleError($event.parameters.error);
                } else if ($event.eventType === 'lendersSent') {
                    $scope.lendersSent = true;
                } else if ($event.eventType === 'track') {
                    if ($event.field.actionTracking) {
                        analyticsService.track(
                            $event.field.actionTracking,
                            $event.field.actionTrackingPayload ? $event.field.actionTrackingPayload : {}
                        );
                    }
                } else if ($event.eventType === 'updatePreferredContactMethod') {
                    $scope.confirmedCoverages.push($event.field.actionTrackingPayload.type);
                } else if ($event.eventType === 'action' && $event.field) {
                    $scope.coverageType = $event.field.type;
                    if ($event.field.actionTracking) {
                        analyticsService.track(
                            $event.field.actionTracking,
                            $event.field.actionTrackingPayload ? $event.field.actionTrackingPayload : {}
                        );
                    }
                    return $scope.showModal($event.field.actionModal).closePromise.then((result) => {
                        // revert if user canceled the operation
                        if (_.isArray(result.value) || (!!result.value && !!result.value.eventType)) {
                            // modals can trigger another event
                            const allEvents = [].concat(result.value); // support list of events
                            _.each(allEvents, (e) => {
                                $scope.handleDeepEvent(e);
                            }); // apply all events
                        } // in this scenario we don't care about all the other scenarios. no revert..
                    });
                } else {
                    $log.error('unhandled deep event', $event);
                }
            };

            function setUpWatchExpressions() {
                if (
                    $scope.pages.checkout &&
                    $scope.pages.checkout.confirmModalBeforePlaceOrder &&
                    $scope.pages.checkout.confirmModalBeforePlaceOrder.deepKey
                ) {
                    $scope.$watch($scope.pages.checkout.confirmModalBeforePlaceOrder.deepKey, (newValue) => {
                        if (newValue) {
                            updateCustomerApproval({ policyInfo: { checkout_data: { customer_approval: true } } });
                        }
                    });
                }
            }

            $scope.tnc_selected = false;
            $scope.disclosures_selected = false;

            $scope.clickTerms = function () {
                $scope.tnc_selected = !$scope.tnc_selected;
                if ($scope.tnc_selected) {
                    $scope.showTncRequiredErrorMessage = false;
                }
            };

            $scope.clickConditions = function () {
                $scope.disclosures_selected = !$scope.disclosures_selected;
                if ($scope.disclosures_selected) {
                    $scope.showDisclosuresRequiredErrorMessage = false;
                }
            };

            $scope.approveAgreement = function () {
                $timeout(() => {
                    $scope.showTncRequiredErrorMessage = !$scope.tnc_selected;
                    $scope.showDisclosuresRequiredErrorMessage = !$scope.disclosures_selected;
                });

                if (!$scope.tnc_selected || !$scope.disclosures_selected) {
                    const element = document.getElementById('the-last-plan-id');
                    element.scrollIntoView();
                    return;
                }

                const checkoutPage = $scope.pages.checkout;
                if (
                    checkoutPage.confirmModalBeforePlaceOrder &&
                    checkoutPage.confirmModalBeforePlaceOrder.event &&
                    checkoutPage.confirmModalBeforePlaceOrder.deepKey
                ) {
                    $scope.handleDeepEvent(checkoutPage.confirmModalBeforePlaceOrder.event);
                } else {
                    updateCustomerApproval({
                        policyInfo: { checkout_data: { customer_approval: true } }
                    });
                }
            };

            if (!userDataService.isProduction() && locationSearch.page === 'confirmation' && approvalId) {
                $scope.approveAgreement();
            } else if (approvalId) {
                // only get the customer approval is relevant
                goToCustomerReviewPage();
            } else {
                $scope.loaded = true;
                handleError();
            }
            // Helper functions
            function getProduct(product) {
                if (product === 'ho3') {
                    return 'HO-3';
                } else if (product === 'ho6') {
                    return 'HO-6';
                } else if (product === 'dp3') {
                    return 'DP-3';
                } else if (product === 'ho5') {
                    return 'HO-5';
                } else {
                    throw new Error(`product ${product} is currently not supported`);
                }
            }

            function getState(license) {
                return (license && license.substring(0, 2)) || 'ca';
            }

            function getCarrier(carrier) {
                return carrier || HIPPO_CONSTS.CARRIERS.TOPA;
            }

            function redirectToReactAgreementPage() {
                let baseReactUrl;

                if ($window.hippoConfig.REACT_REDIRECT_URL) {
                    baseReactUrl = $window.hippoConfig.REACT_REDIRECT_URL;
                } else if ($window.hippoConfig.API_HOST) {
                    const apiHostOrigin = new URL($window.hippoConfig.API_HOST).origin;
                    baseReactUrl = apiHostOrigin.replace('api', 'leadflow');
                } else {
                    baseReactUrl = 'https://www.hippo.com';
                }

                $window.location.href = baseReactUrl + '/agreement?agreementId=' + approvalId;
            }

            function goToCustomerReviewPage() {
                const getCustomerApprovalPromise = showMockData
                    ? $http.get('/get-customer-agreement.json')
                    : apiService.customerApproval.getCustomerApproval(approvalId, true);

                getCustomerApprovalPromise.then(
                    (data) => {
                        const policyInfo = data.data.policyInfo;
                        const firstName = policyInfo.personal_information.first_name || '';
                        const lastName = policyInfo.personal_information.last_name || '';
                        const fullName = `${_.capitalize(firstName)} ${_.capitalize(lastName)}`;
                        const state = getState(policyInfo.additionalInfo.license);
                        const carrier = getCarrier(policyInfo.carrier);
                        const mortgageLenders = policyInfo.property_data.mortgages;
                        const product = getProduct(policyInfo.product);

                        if (policyInfo.product !== 'ho5') {
                            redirectToReactAgreementPage();
                        }

                        if (mortgageLenders && mortgageLenders.details) {
                            $scope.lenders = mortgageLenders.details;
                        }

                        if (policyInfo.applicationDocuments && policyInfo.product !== 'ho5') {
                            const applicationDocumentLink = _.maxBy(
                                policyInfo.applicationDocuments,
                                (doc) => doc.created_at
                            ).url;

                            overrides[0].legalFooterHtml = `By clicking “I Accept”, you agree to each of the following:
        <ul>
          <li>Affirm you are the named insured.</li>
          <li>Declare that the information provided in this <a rel="noopener noreferrer" target="_blank" href="${applicationDocumentLink}">application and all attachments</a> is correct and complete to the best of your knowledge.</li>
          <li>Acknowledge you are electronically signing for the insurance indicated.</li>
        </ul>`;
                        }

                        $scope.notionDiscount = policyInfo.notion_discount;
                        $scope.confirmation = data.confirmation;
                        $scope.leadData = {
                            isAgentCreatedPolicy: policyInfo.is_agent,
                            showExitSurvey: policyInfo.show_exit_survey,
                            personal_information: policyInfo.personal_information,
                            quote: _.clone(policyInfo.quote),
                            property_data: policyInfo.property_data,
                            additionalInfo: policyInfo.additionalInfo,
                            product
                        };

                        // Generate Pages after we determine state and product
                        $scope.pages = generatePages(
                            state,
                            product,
                            fullName,
                            carrier,
                            policyInfo.additionalInfo.flowCustomizationKey
                        );

                        const finalQuotePage = $scope.pages['final-quote'];

                        $scope.page = pageGenerator.generatePage(finalQuotePage, { leadData: $scope.leadData });
                        setUpWatchExpressions();

                        $scope.additionalInfo = policyInfo.additionalInfo;
                        $scope.modals = WorkflowPlan.getModals(
                            state,
                            product,
                            carrier,
                            policyInfo.additionalInfo.flowCustomizationKey
                        );
                        $scope.loaded = true;
                    },
                    (error) => {
                        handleError(error);
                        $scope.loaded = true;
                    }
                );
            }

            $scope.goToConfirmationPage = (data) => {
                // Check to make sure there is a confirmation page. If not, generate

                if (!$scope.pages['confirmation']) {
                    if (!$scope.leadData) $scope.leadData = data.lead_data;
                    const state = getState(data.additionalInfo.license);
                    const product = getProduct(data.product);
                    const carrier = getCarrier(data.carrier);
                    $scope.pages = generatePages(state, product, '', carrier);
                    $scope.modals = WorkflowPlan.getModals(state, product, carrier);
                }

                $scope.confirmation = _.clone(data);
                $scope.leadData.checkout_data = data.lead_data.checkout_data;
                $scope.page = pageGenerator.generatePage($scope.pages['confirmation'], {
                    leadData: data.lead_data,
                    confirmation: $scope.confirmation
                });

                $scope.confirmationLarge = featureToggle.isConfirmationAnimating();
                $scope.confirmationSmall = !featureToggle.isConfirmationAnimating();
                $scope.confirmationShow = !featureToggle.isConfirmationAnimating();

                if (locationSearch.disableAnimation === 'true') {
                    $scope.confirmationSmall = true;
                    $scope.confirmationShow = true;
                    return;
                }
                $timeout(function () {
                    $scope.confirmationLarge = false;
                    $scope.confirmationSmall = true;
                }, 3500);
                $timeout(function () {
                    $scope.confirmationShow = true;
                    if ($scope.leadData.showExitSurvey || $scope.leadData.isAgentCreatedPolicy) {
                        $scope.showModal('purchaseSurvey');
                    }
                }, 3900);
            };

            let updateCustomerApprovalMutex = false;
            function updateCustomerApproval(data) {
                // Deal with show mock
                if (showMockData) {
                    return $http.get('/post-customer-agreement.json').then(
                        (result) => {
                            // response from backend
                            $scope.goToConfirmationPage(result.data);
                        },
                        (error) => {
                            // error from backend
                            $scope.page = defaultErrorPage;
                            $log.error('got an error from backend', error);
                        }
                    );
                }

                // Check if an updateCustomerApproval call is in progress via the mutex
                if (updateCustomerApprovalMutex) {
                    return;
                }
                // No call in progress, update mutex and proceed with making the call
                updateCustomerApprovalMutex = true;
                return apiService.customerApproval
                    .updateCustomerApproval(approvalId, data)
                    .then(
                        (result) => {
                            // response from backend
                            $scope.goToConfirmationPage(result.data);
                        },
                        (error) => {
                            // error from backend
                            $scope.page = defaultErrorPage;
                            $log.error('got an error from backend', error);
                        }
                    )
                    .finally(() => {
                        updateCustomerApprovalMutex = false;
                    });
            }

            $scope.activeModal = false;
            $scope.activeModalShowing = false;

            $scope.setActiveModalTab = function (menuItem) {
                if (document.body.clientWidth < 600 && $scope.activeModalTab === menuItem) {
                    $scope.activeModalTab = null;
                } else {
                    $scope.activeModalTab = menuItem;
                }
            };

            /**
             *
             * @param {string} modal - modal name
             * @param event
             * @param type
             */
            $scope.showModal = function (modal, event, type) {
                if (modal in $scope.modals) {
                    const modalName = modal;
                    modal = $scope.modals[modal];
                    const modalScope = $scope.$new(true);

                    modalScope.data = {
                        leadData: $scope.leadData,
                        confirmation: $scope.confirmation,
                        leadId: $scope.leadId,
                        coverageType: $scope.coverageType,
                        confirmedCoverages: $scope.confirmedCoverages,
                        page: $scope.pages[$scope.activePage] || $scope.page,
                        lenders: $scope.lenders
                    };

                    modalScope.modal = pageGenerator.generatePage(modal, modalScope.data);

                    const directiveName = `${_.kebabCase(modal.type)}-modal`;
                    return ngDialog.open({
                        template: `<${directiveName} modal="modal" data="data" on-event="handleDeepEvent($event)" modal-confirm-exit></${directiveName}>`,
                        scope: modalScope,
                        appendClassName: 'hippo-' + directiveName + ' ' + _.kebabCase(modalName),
                        name: 'hippo-' + directiveName,
                        preCloseCallback: function (reason) {
                            // $escape , $document // guy - using this callback this is a trick to catch all close events. not all are caught by 'closeThisDialog'
                            $log.info('preclose hook is running in ctrl.js. reason is: ', reason);
                            if (typeof reason !== 'object') {
                                return $(`[modal-confirm-exit]`).scope().externalTriggerClose(reason);
                            }
                            return true;
                        }
                    });
                } else {
                    $log.error(new Error('modal ' + modal + ' does not exist, but was requested'));
                }
                if (event) {
                    event.stopPropagation();
                    event.preventDefault();
                }
            };

            document.addEventListener('keyup', function (event) {
                if (event.which === 27) {
                    // 27 = esc key
                    $scope.$apply(function () {
                        $scope.cancelModal();
                    });
                    event.preventDefault();
                }
            });

            $scope.modalDataValid = function () {
                if ($scope.activeModal.functions && typeof $scope.activeModal.functions.validate === 'function') {
                    return $scope.activeModal.functions.validate($scope);
                } else {
                    return true;
                }
            };
        }
    );
